export function isGonserBoxItem(variationProperties)
{
    if (!Array.isArray(variationProperties))
    {
        return false;
    }

    for (const propertyGroup of variationProperties)
    {
        if (!propertyGroup)
        {
            continue;
        }

        const properties = Array.isArray(propertyGroup.properties)
            ? propertyGroup.properties
            : [];

        for (const property of properties)
        {
            if (isGonserBoxProperty(property))
            {
                return true;
            }
        }

        if (propertyGroup.property && isGonserBoxProperty(propertyGroup.property, propertyGroup.values))
        {
            return true;
        }
    }

    return false;
}

function isGonserBoxProperty(property, valuesOverride)
{
    if (!property || Number(property.id) !== 4)
    {
        return false;
    }

    const values = valuesOverride ?? property.values;

    if (!values)
    {
        return false;
    }

    if (Array.isArray(values))
    {
        return values.some(value => value && value.value === "1");
    }

    return values.value === "1";
}
